import { addWeeks, endOfWeek, startOfWeek } from "date-fns";

export type WeekSummary = {
  weekStart: Date;
  weekEnd: Date;
  completed: number;
  goal: number;
  met: boolean;
};

export function buildWeeklySummariesSinceJoin(params: {
  joinedAt: Date;
  now: Date;
  weeklyGoal: number;
  completedByWeekStartISO?: Record<string, number>;
}): WeekSummary[] {
  const { joinedAt, now, weeklyGoal, completedByWeekStartISO = {} } = params;
  const joinedWeekStart = startOfWeek(joinedAt, { weekStartsOn: 0 });
  const currentWeekStart = startOfWeek(now, { weekStartsOn: 0 });

  const out: WeekSummary[] = [];
  for (let d = joinedWeekStart; d <= currentWeekStart; d = addWeeks(d, 1)) {
    const weekStart = d;
    const weekEnd = endOfWeek(weekStart, { weekStartsOn: 0 });
    const key = weekStart.toISOString().slice(0, 10); // yyyy-mm-dd (local-ish stable key)
    const completed = completedByWeekStartISO[key] ?? 0;
    out.push({
      weekStart,
      weekEnd,
      completed,
      goal: weeklyGoal,
      met: completed >= weeklyGoal,
    });
  }
  return out;
}

export function computeCurrentStreakWeeks(weeks: WeekSummary[]): number {
  let streak = 0;
  for (let i = weeks.length - 1; i >= 0; i -= 1) {
    if (!weeks[i]?.met) break;
    streak += 1;
  }
  return streak;
}

export function computeBestStreakWeeks(weeks: WeekSummary[]): number {
  let best = 0;
  let current = 0;
  for (const w of weeks) {
    if (w.met) {
      current += 1;
      if (current > best) best = current;
    } else {
      current = 0;
    }
  }
  return best;
}

export function computeMetPercentage(weeks: WeekSummary[]): number {
  if (weeks.length === 0) return 0;
  const metCount = weeks.reduce((acc, w) => acc + (w.met ? 1 : 0), 0);
  return Math.round((metCount / weeks.length) * 100);
}


